import { render, staticRenderFns } from "./ContratacaoAnexoDownload.vue?vue&type=template&id=d4c94a18"
import script from "./ContratacaoAnexoDownload.vue?vue&type=script&lang=js"
export * from "./ContratacaoAnexoDownload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports